<template>
  <div class="read-more">
    <span v-if="!expanded && truncatedText" class="block text-sm text-slate-600">
      <span v-html="truncatedText"></span>
      <button 
        @click="expanded = true" 
        class="text-primary hover:text-primary-dark cursor-pointer ml-1"
      >
        {{ moreStr }}
      </button>
    </span>
    <span v-else-if="expanded" class="block text-sm text-slate-600">
      <span v-html="text"></span>
      <button 
        @click="expanded = false" 
        class="text-primary hover:text-primary-dark cursor-pointer ml-1"
      >
        {{ lessStr }}
      </button>
    </span>
    <span v-else class="block text-sm text-slate-600">
      <span v-html="text"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ReadMore',
  props: {
    text: {
      type: String,
      required: true
    },
    maxChars: {
      type: Number,
      default: 50
    },
    moreStr: {
      type: String,
      default: 'read more'
    },
    lessStr: {
      type: String,
      default: 'read less'
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    truncatedText() {
      if (this.text && this.text.length > this.maxChars) {
        return this.text.substring(0, this.maxChars) + '...';
      }
      return null;
    }
  }
}
</script>

